import React, { ReactNode } from 'react';
import { Mode } from '@/components/Mode';
import styles from './PageTitle.module.scss';
import { Eyebrow } from '../Eyebrow/Eybrow';

export interface PageTitleInterface {
  mode?: Mode | string;
  rate?: number;
  title: ReactNode | string;
  cohort: 'owner' | 'investor';
  titleEyebrow: string;
}

export const PageTitle = ({
  mode = Mode.LIGHT,
  titleEyebrow,
  rate = 0,
  title = '',
  cohort = 'owner',
}: PageTitleInterface) => {
  const homeOwnersRateTitle = (
    <p className={styles.rateTitle}>
      RATES FOR HOME <br />
      OWNERS FROM
    </p>
  );
  const investorRateTitle = (
    <p className={styles.rateTitle}>
      RATES FOR <br />
      INVESTORS FROM
    </p>
  );

  const ref = React.useRef(null);

  /* Load trustpilot once it is available from the ref */
  React.useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  const activeRateTitle = cohort === 'owner' ? homeOwnersRateTitle : investorRateTitle;
  return (
    <div>
      <div className={`${styles.root} ${styles[mode]}`}>
        <div className={styles.eyebrow}>
          <Eyebrow element="h1">{titleEyebrow}</Eyebrow>
        </div>
        <div className={`${styles.titleAndRateContainer}`}>
          <p className={styles.title}>
            <strong style={{ fontWeight: 'inherit' }}>{title}</strong>
          </p>
          {!!rate && (
            <div className={styles.rateContainer}>
              {activeRateTitle}
              <div>
                <div className={styles.numberContainer}>
                  <p className={styles.rate}>{`${rate}`}</p>
                  <div>
                    <p className={styles.ratePercent}>%</p>
                    <p className={styles.ratePA}>P.A.</p>
                  </div>
                </div>
                <div className={styles.rateContainerSubtext}>Variable & Comparison^</div>
              </div>
            </div>
          )}
        </div>
        <div className={styles.trustPilotContainer}>
          {/* <!-- TrustBox widget - Micro Combo --> */}
          <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id="5c08b592390696000193c25d"
            data-style-height="32px"
            data-style-width="100%"
            data-theme="light"
          />
          {/* <!-- End TrustBox widget --> */}
        </div>
      </div>
    </div>
  );
};
